import React from 'react';
type Col = { key: string; label: string; grow?: boolean };
export default function SimpleTable({ rows, columns }: Readonly<{ rows: any[]; columns: Col[] }>) {
  if (!rows?.length) return <div style={{ color: '#6b7280' }}>No data</div>;
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: columns.map((c) => (c.grow ? '1fr' : 'auto')).join(' '),
        gap: 6,
      }}
    >
      {columns.map((c, i) => (
        <div key={i} style={{ fontSize: 12, color: '#6b7280' }}>
          {c.label}
        </div>
      ))}
      {rows.map((r, idx) => (
        <React.Fragment key={idx}>
          {columns.map((c, i) => (
            <div
              key={i}
              style={{
                whiteSpace: c.grow ? 'nowrap' : 'normal',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: '#111827',
                fontSize:13,
              }}
            >
              {String(r[c.key] ?? '')}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}
